import * as React from 'react';

import { emitErrorToast } from '../toast';


export type ErrorBoundaryProps = {};

type ErrorBoundaryState = {
	hasError: boolean;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
	state = {
		hasError: false,
	};

	static getDerivedStateFromError(error) {

		emitErrorToast({
			content: error.stack,
		});

		return { hasError: true };
	};

	render() {
		if (this.state.hasError) {
			return null;
		}

		return this.props.children;
	}
}

export default ErrorBoundary;